import BaseClient from './BaseClient';

class OrgUnitsClient extends BaseClient {
    listOrgUnits(teamId, params, config) {
        const url = `/api/v3/teams/${teamId}/org-units`;
        return this.makeCoreApiRequest(url, 'get', null, params, config);
    }

    countOrgUnits(teamId) {
        const url = `/api/v3/teams/${teamId}/org-units/count`;
        return this.makeCoreApiRequest(url, 'get');
    }

    showOrgUnit(teamId, orgUnitId) {
        const url = `/api/v3/teams/${teamId}/org-units/${orgUnitId}`;
        return this.makeCoreApiRequest(url, 'get');
    }

    createOrgUnit(teamId, data) {
        const url = `/api/v3/teams/${teamId}/org-units`;
        return this.makeCoreApiRequest(url, 'post', data);
    }

    updateOrgUnit(teamId, orgUnitId, data) {
        const url = `/api/v3/teams/${teamId}/org-units/${orgUnitId}`;
        return this.makeCoreApiRequest(url, 'put', data);
    }

    deleteOrgUnit(teamId, orgUnitId) {
        const url = `/api/v3/teams/${teamId}/org-units/${orgUnitId}`;
        return this.makeCoreApiRequest(url, 'delete');
    }

    bulkMoveGroups(teamId, sourceOrgUnitId, targetOrgUnitId) {
        const url = `/api/v3/teams/${teamId}/org-units/bulk-move-groups`;
        return this.makeCoreApiRequest(url, 'post', {
            source_org_unit_id: sourceOrgUnitId,
            target_org_unit_id: targetOrgUnitId,
        });
    }

    bulkRemoveGroups(teamId, orgUnitId) {
        const url = `/api/v3/teams/${teamId}/org-units/bulk-remove-groups`;
        return this.makeCoreApiRequest(url, 'post', {
            org_unit_id: orgUnitId,
        });
    }
}

export default new OrgUnitsClient();
